module.exports = __webpack_public_path__ + "img/anfas-example.3f3c5d30.jpg";